module.exports = fox._r("images/promo/logo-small-blue.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/logo-small-blue.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/logo-small-blue.png
// module id = 170
// module chunks = 2